import { Grid, IconButton, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import { MouseEventHandler } from 'react';
import { ORBIT_DETAIL } from '../../../../../../routes/paths';
import { OrbitHistoryListActionsProps } from './props';

export const OrbitHistoryListActions = ({
    orbitCaseId,
}: OrbitHistoryListActionsProps) => {
    const navigate = useNavigate();

    const handleView: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        if (!orbitCaseId) return;
        navigate(`${ORBIT_DETAIL}/${encodeURIComponent(orbitCaseId)}`);
    };

    return (
        <Grid textAlign="left" width="100%" className="no-click-cell">
            <Tooltip title="Ver detalle">
                <IconButton size="small" onClick={handleView}>
                    <VisibilityIcon
                        fontSize="small"
                        sx={{ color: 'primary.main' }}
                    />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
